import { call, put } from 'redux-saga/effects';
import { ActionType } from 'deox';

import { checkAccessToken } from '@/utils/handle-authentication';
import { updateRoleEmployeeAction } from '@/redux/actions/employee';
import { updateRoleEmployee, TUpdateRoleEmployeeResponse } from '@/services/api/employee';
import { handleAPIError } from '@/utils/handle-api-error';

// FUNCTION
export function* updateRoleEmployeeSaga(action: ActionType<typeof updateRoleEmployeeAction.request>): Generator {
  const { materials, companyId, employeeId, successCallback, failedCallback } = action.payload;
  try {
    yield call(checkAccessToken);
    const response = yield call(updateRoleEmployee, materials, companyId, employeeId);
    const updateProfileEmployeeResponse: TUpdateRoleEmployeeResponse = response as TUpdateRoleEmployeeResponse;
    yield put(updateRoleEmployeeAction.success(updateProfileEmployeeResponse));
    successCallback?.(updateProfileEmployeeResponse);
  } catch (err) {
    yield put(updateRoleEmployeeAction.failure(err));
    failedCallback?.(err);
    handleAPIError(err, 'Error.editEmployeeInfoError');
  }
}
